import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgQL = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 305,
	height: 401,
	fill: "none",
	viewBox: "0 0 305 401",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			fill: "#43a9f1",
			d: "m267.2 120.15-26.58.14c-16.2-63.1-51.01-90.44-86.01-91.68 64.97-5.04 100.2 41.37 112.58 91.54"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "url(#paint0_linear_27738_4876)",
			fillOpacity: .38,
			d: "M147.14 176.03c-45.16-45.4-9.99-69.64 8.88-72.31-6.04-9.6-25.93-22.83-51.26-.4-31.67 28.05-11.72 56.37-1.13 69.3 5.71 8.51 54.68 37.8 72.67 53.11 9.51 22.43 16.52 52.18 16.52 52.18l29.45-17.14c-4.28-12.88-12.62-39.5-16.4-43.95-11.34-13.38-14.09-4.97-58.73-40.8"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#1577bf",
			stroke: "#80a7de",
			strokeWidth: 1.51,
			d: "m240.75 119.86 26.55.65-60.8 21.48-32.96 2.86z"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "#accdff",
			strokeWidth: 2.26,
			d: "m192.6 277.19 29.67-16.42c-3.36-12.89-11.96-35.4-13.87-39.49-4.52-9.65-15.15-13.7-46.97-34.4-14.84-10.08-43.42-37.42-34.46-59.45 9.5-23.33 26.88-23.06 30.1-22.85"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "url(#paint1_linear_27738_4876)",
			stroke: "#accdff",
			strokeWidth: 1.51,
			d: "M112.06 36.26c84.23-31.7 120.48 42.08 128.08 82.93l-66.37 25.14c-7.07-44.3-36-69.8-70.45-40.52-32.5 27.62-5.53 63.13-.44 68.98 8.44 9.71 34.28 26.25 53.6 38.13 19.31 11.87 19.1 15.09 21.6 19.45 2.01 3.51 10.51 32.69 14.15 46.93l-56.11 12.2c-1.85-6.12-2.85-12.9-11.45-28.8s-51.16-14.47-75.14-50.9c-65.2-99.1 18.8-158.51 62.53-173.54Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "#accdff",
			strokeWidth: 2.26,
			d: "M112.06 36.26c84.23-31.7 120.48 42.08 128.08 82.93l-66.37 25.14c-7.07-44.3-36-69.8-70.45-40.52-32.5 27.62-5.53 63.13-.44 68.98 8.44 9.71 34.28 26.25 53.6 38.13 19.31 11.87 19.1 15.09 21.6 19.45 2.01 3.51 10.51 32.69 14.15 46.93l-56.11 12.2c-1.85-6.12-2.85-12.9-11.45-28.8s-51.16-14.47-75.14-50.9c-65.2-99.1 18.8-158.51 62.53-173.54Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "#accdff",
			strokeWidth: 2.26,
			d: "m192.84 277.5 29.66-16.43c-3.36-12.88-11.96-35.38-13.87-39.48-4.52-9.65-15.15-13.7-46.97-34.4-14.84-10.08-43.42-37.42-34.45-59.46 9.49-23.32 26.88-23.05 30.09-22.84"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#55a9f9",
			fillOpacity: .43,
			d: "m207.25 319.3 19.03 63.1-62.23 6.29-17.83-59.12z"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "#accdff",
			strokeWidth: 1.51,
			d: "m235.75 297.72 17.35 57.52-26.82 27.16m0 0-19.03-63.1-61.03 10.27 17.83 59.12z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#8ec9ff",
			d: "m252.8 355.52-17.41-57.7-27.78 21.37 19.03 63.1z",
			opacity: .6
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#0d1c36",
			fillOpacity: .11,
			stroke: "#accdff",
			strokeWidth: 2.26,
			d: "m207.5 318.83 28.5-21.58-55.72 10.9-34.35 21.77z"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "#accdff",
			strokeWidth: 2.26,
			d: "m235.75 297.72 17.35 57.52-26.82 27.16m0 0-19.03-63.1-61.03 10.27 17.83 59.12z"
		}),
		/* @__PURE__ */ _jsxs("defs", { children: [/* @__PURE__ */ _jsxs("linearGradient", {
			id: "paint0_linear_27738_4876",
			x1: 119.13,
			x2: 159.72,
			y1: 93.6,
			y2: 264.68,
			gradientUnits: "userSpaceOnUse",
			children: [
				/* @__PURE__ */ _jsx("stop", {
					stopColor: "#fff",
					stopOpacity: .18
				}),
				/* @__PURE__ */ _jsx("stop", {
					offset: .3,
					stopColor: "#ddd"
				}),
				/* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#fff",
					stopOpacity: .45
				})
			]
		}), /* @__PURE__ */ _jsxs("linearGradient", {
			id: "paint1_linear_27738_4876",
			x1: 38.27,
			x2: 243.39,
			y1: 158.11,
			y2: 49.04,
			gradientUnits: "userSpaceOnUse",
			children: [/* @__PURE__ */ _jsx("stop", {
				stopColor: "#fff",
				stopOpacity: 0
			}), /* @__PURE__ */ _jsx("stop", {
				offset: 1,
				stopColor: "#fff",
				stopOpacity: .17
			})]
		})] })
	]
});
export default SvgQL;
